import { AnyError } from '../core/types';
import { isErrorToManage } from './utils';

/**
 * Check whether the error should be raised to ErrorBoundary component or not.
 *
 * @param {AnyError} error
 * @returns {boolean}
 */
export function shouldRaiseErrorToErrorBoundary(error: AnyError): boolean {
  return isErrorToManage(error);
}
